export const nthSegment = (path: string, segmentNum: number): string => path.split('/')[segmentNum];
